// MARK: React
import * as React from "react";
import "./style.scss";

// Mobx
import { observer } from "mobx-react";
import HotelStore from "../../../../../stores/HotelStore";

// Components
import TextField from "../../../../../components/TextField";
import MaskedTextField from "../../../../../components/MaskedTextField";

// Resources
import strings from "../../../../../resources/strings";

interface IProps {
	hotelStore: HotelStore;
}

@observer
export default class HotelSocialForm extends React.Component<IProps> {
	public render() {
		const { hotelStore } = this.props;
		return (
			<>
				<h2 className="editHotelTitle">{strings.hotel.edit.sections.socialMedia}</h2>
				<div className="hotelSocialForm">
					<TextField
						label={strings.hotel.edit.fields.socialMedia.instagram}
						name="instagram"
						value={hotelStore.instagram}
						onChange={hotelStore.handleValueChange}
						disabled={hotelStore.loading}
					/>
					<TextField
						label={strings.hotel.edit.fields.socialMedia.facebook}
						name="facebook"
						value={hotelStore.facebook}
						onChange={hotelStore.handleValueChange}
						disabled={hotelStore.loading}
					/>
					<TextField
						label={strings.hotel.edit.fields.socialMedia.linkedin}
						name="linkedin"
						value={hotelStore.linkedin}
						onChange={hotelStore.handleValueChange}
						disabled={hotelStore.loading}
					/>
				</div>
			</>
		);
	}
}
